/**
 * bootFighterBuffOverlay — Attach fighter passive readability overlay (SPY-112).
 */
import {
  createFighterBuffOverlay,
  syncFighterBuffFromEntity
} from './vfx/fighterBuffOverlay.js';
import { getFighterBuffReadability } from '../domain/champions/fighterBuffReadability.js';

/**
 * @param {{ THREE: object, parent: object, getChampion: () => object, globalObj?: object }} opts
 */
export function bootFighterBuffOverlay({ THREE, parent, getChampion, globalObj = globalThis }) {
  const overlay = createFighterBuffOverlay(THREE);
  if (parent && typeof parent.add === 'function') parent.add(overlay.group);
  function tick(dt = 0) {
    syncFighterBuffFromEntity(overlay, getChampion?.() || null, dt);
  }
  if (globalObj) {
    globalObj.__debugFighterBuff = {
      get: () => getFighterBuffReadability(getChampion?.() || null),
      tick: () => tick(0.016)
    };
  }
  return { overlay, tick };
}
